<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetCreditCalculator } from '~/components/widget/credit-calculator'
import { WidgetSeoContent, WidgetSeoHeroBanner } from '~/components/widget/seo'
import { WidgetSelectCreditType } from '~/components/widget/select-credit-type'
import { WidgetCreditTypePills } from '~/components/widget/credit-type-pills'
import type { IResponseData } from '~/types'

const { t } = useI18n()

const { data: creditTypeData } = await useApi<IResponseData<{ title: string }>>(
  '/credit_types/mortgage',
  { key: 'credit-type-mortgage-calculator' }
)

const creditTypeTitle = computed(() => creditTypeData.value?.data?.title || t('common.mortgage'))

const breadcrumbs = computed(() => [
  { title: t('common.credits'), url: '/credits' },
  { title: t('page.mortgage_calculator.breadcrumb') }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <!-- Below `xl` the type menu is rendered above the calculator instead -->
            <WidgetSelectCreditType
              :query-params="{ 'filter[position]': 'sidebar' }"
              class="hidden xl:block"
            />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="space-y-5" role="main">
          <WidgetSeoHeroBanner
            :heading="creditTypeTitle"
            text=""
            image="/images/photostock/credits.avif"
          />
          <WidgetCreditTypePills />
          <WidgetCreditCalculator is-category-page />
          <WidgetSeoContent position="bottom" />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
